import { apiSlice } from "../../app/apiSlice";
import configUrls from "../../config/configUrls";
import { Marcador } from "../../types/marcador/Marcador";
import { MarcadorDTO } from "../../types/marcador/MarcadorDTO";
import { MarcadorList } from "../../types/marcador/MarcadorList";


const endpointUrl = configUrls.MARCADOR_EP

function getMarcadores({ search }: { search: string }) {
    return {
        url: `${endpointUrl}/filter?search=${search}`,
        method: "GET",
    }
}


function addMarcador(obj: MarcadorDTO) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function deleteMarcador({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}
function getMarcador(id: string) {
    if (!id) {

        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/${id}`,
        method: "GET",
    }
}
/** */


export const marcadorApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({


        getMarcadores: query<MarcadorList[], { search: string }>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,            
            query: getMarcadores,
            providesTags: ["Marcador"],
        }),

        getMarcador: query<Marcador, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getMarcador,
            providesTags: ["Marcador"],
        }),
        addMarcador: mutation<void, MarcadorDTO>({
            query: addMarcador,
            invalidatesTags: ["Marcador"]
        }),
        deleteMarcador: mutation<void, { id: string }>(
            {
                query: deleteMarcador,
                invalidatesTags: ["Marcador"],
            }),
    }),

});
export const {
    useGetMarcadoresQuery,
    useGetMarcadorQuery,
    useAddMarcadorMutation,
    useDeleteMarcadorMutation,
} = marcadorApiSlice